import { Component, isDevMode, inject } from '@angular/core';
//import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogService } from '@kildencore/services/dialog.service';
import { ObjectinfoService } from '@kildencore/services/objectinfo.service';
import { DebugToolService } from '@kildenshared/components/debug-tool/debug-tool.service';
import { Kilden3DialogComponent } from '@kildenshared/components/dialog/dialog.component';
import { environment } from 'src/environments/environment';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'kilden3-debug-tool',
  templateUrl: './debug-tool.component.html',
  styleUrls: ['./debug-tool.component.css'],
  imports: [JsonPipe],
})
export class DebugToolComponent {
  readonly debugToolService = inject(DebugToolService);
  readonly dialogService = inject(DialogService);
  readonly objectinfoService = inject(ObjectinfoService);

  protected readonly isDevMode = isDevMode;
  protected readonly environment = environment;

  protected dialogRef: MatDialogRef<Kilden3DialogComponent> | undefined;
}
